import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { Siren } from 'lucide-react';

export default function EmergencyQuickButton() {
  const { t } = useLang();
  return (
    <a href="/emergency-services" data-testid="emergency-sticky-button"
      className="lg:hidden fixed bottom-4 left-4 right-4 z-40 flex items-center justify-center gap-2 bg-[#E11D2A] hover:bg-[#C41623] text-white font-bold py-3.5 rounded-full shadow-lg shadow-[#E11D2A]/30 transition-all">
      <Siren className="w-5 h-5" />
      <span className="text-sm tracking-wide uppercase">{t.emergency.navBtn}</span>
    </a>
  );
}
